import { render, staticRenderFns } from "./SystemMetaTabCopy.vue?vue&type=template&id=4a97adba"
import script from "./SystemMetaTabCopy.vue?vue&type=script&lang=js"
export * from "./SystemMetaTabCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports